<div class="page-container" [testId]="'personal-channel-container'">
  <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n" class="page-spin">
    <div class="personal-channel-container" [testId]="'personal-channel-main-container'">
      <div class="operation-mask" *ngIf="operationMaskVisible" [testId]="'personal-channel-operation-mask'">
        <div class="operation-mask__panel" [testId]="'personal-channel-operation-mask-panel'">
          <div class="ios-spinner" aria-hidden="true" [testId]="'personal-channel-operation-mask-spinner'">
            <span *ngFor="let tick of iosSpinnerTicks; let index = index" [style.--tick-index]="index"></span>
          </div>
          <div class="operation-mask__text" [testId]="'personal-channel-operation-mask-text'">{{ operationMaskText }}</div>
          <div class="operation-mask__hint" [testId]="'personal-channel-operation-mask-hint'">
            {{ operationMaskHintText }}
          </div>
        </div>
      </div>
      <div class="page-topbar" [testId]="'personal-channel-header'">
        <div class="header-section">
          <div class="title-section" [testId]="'personal-channel-title-section'">
            <h3 class="page-title" [testId]="'personal-channel-title'">{{ 'tenant.channel.personal.title' | i18n }}</h3>
          </div>
          <div class="header-actions">
            <button
              nz-button
              nzType="default"
              class="line-guide-trigger"
              (click)="openLineGuide()"
              [testId]="'personal-channel-line-guide-button'"
            >
              <i nz-icon nzType="book"></i>
              {{ 'tenant.channel.personal.line-guide-action' | i18n }}
            </button>
            <button
              nz-button
              nzType="default"
              [nzLoading]="loading"
              (click)="loadChannelConfigs()"
              [testId]="'personal-channel-refresh-button'"
            >
              <i nz-icon nzType="reload" nzTheme="outline"></i>
              <span>{{ 'common.refresh' | i18n }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- 渠道连接入口：卡片栅格展示 -->
      <div class="channel-card-grid" [testId]="'personal-channel-card-grid'">
        <nz-row [nzGutter]="16" [testId]="'personal-channel-card-row'">
          <!-- LINE Login 卡片（始终显示；根据是否已串接切换按钮与状态） -->
          <nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8" [testId]="'personal-channel-card-col-line-login'">
            <nz-card class="channel-card card-line-login" [testId]="'personal-channel-card-line-login'">
              <div class="card-header" [testId]="'personal-channel-card-line-login-header'">
                <img
                  [src]="getChannelIcon(CHANNEL_TYPE.LINE_LOGIN)"
                  class="card-icon"
                  [attr.alt]="'tenant.channel.personal.line-login-name' | i18n"
                  [testId]="'personal-channel-card-line-login-icon'"
                />
                <div class="card-title" [testId]="'personal-channel-card-line-login-title'">{{
                  'tenant.channel.personal.line-login.title' | i18n
                }}</div>
                <div
                  class="card-status"
                  *ngIf="hasChannelType(CHANNEL_TYPE.LINE_LOGIN)"
                  [testId]="'personal-channel-card-line-login-status'"
                >
                  <i nz-icon nzType="check-circle" nzTheme="fill"></i>
                  <span>{{ 'tenant.channel.personal.connected' | i18n }}</span>
                </div>
                <div
                  class="card-status"
                  [ngClass]="getLineLoginStatusClass()"
                  *ngIf="getLineLoginStatusText()"
                  [testId]="'personal-channel-card-line-login-processing-status'"
                >
                  <i nz-icon [nzType]="getLineLoginStatusClass() ? 'close-circle' : 'info-circle'" nzTheme="fill"></i>
                  <span>{{ getLineLoginStatusText() }}</span>
                </div>
              </div>
              <div class="card-body" [testId]="'personal-channel-card-line-login-body'">
                <p class="card-desc" [testId]="'personal-channel-card-line-login-desc'">{{
                  'tenant.channel.personal.line-login.desc' | i18n
                }}</p>
              </div>
              <div class="card-actions" [testId]="'personal-channel-card-line-login-actions'">
                <ng-container *ngIf="!hasLineLoginBindingData(); else lineLoginDisconnect">
                  <button
                    nz-button
                    nzType="primary"
                    [disabled]="isChannelConnectDisabled(CHANNEL_TYPE.LINE_LOGIN)"
                    (click)="openChannelModal(CHANNEL_TYPE.LINE_LOGIN)"
                    [testId]="'personal-channel-card-line-login-start'"
                  >
                    {{ 'tenant.channel.personal.connect' | i18n }}
                  </button>
                </ng-container>
                <ng-template #lineLoginDisconnect>
                  <button nz-button nzType="default" (click)="unbindLineLogin()" [testId]="'personal-channel-card-line-login-unbind'">
                    {{ 'tenant.channel.personal.disconnect' | i18n }}
                  </button>
                </ng-template>
              </div>
              <div class="card-error" *ngIf="getLineLoginFailureReason()" [testId]="'personal-channel-card-line-login-error-reason'">
                <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
                <span>{{ getLineLoginFailureReason() }}</span>
              </div>
            </nz-card>
          </nz-col>

          <!-- LINE OA 卡片（始终显示；未完成 LINE Login 时禁用连接） -->
          <nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8" [testId]="'personal-channel-card-col-line-oa'">
            <nz-card class="channel-card card-line-oa" [testId]="'personal-channel-card-line-oa'">
              <div class="card-header" [testId]="'personal-channel-card-line-oa-header'">
                <img
                  [src]="getChannelIcon(CHANNEL_TYPE.LINE_OA)"
                  class="card-icon"
                  [attr.alt]="'tenant.channel.personal.line-oa-name' | i18n"
                  [testId]="'personal-channel-card-line-oa-icon'"
                />
                <div class="card-title" [testId]="'personal-channel-card-line-oa-title'">{{
                  'tenant.channel.personal.line-oa.title' | i18n
                }}</div>
                <div class="card-status" *ngIf="hasChannelType(CHANNEL_TYPE.LINE_OA)" [testId]="'personal-channel-card-line-oa-status'">
                  <i nz-icon nzType="check-circle" nzTheme="fill"></i>
                  <span>{{ 'tenant.channel.personal.connected' | i18n }}</span>
                </div>
              </div>
              <div class="card-body" [testId]="'personal-channel-card-line-oa-body'">
                <p class="card-desc" [testId]="'personal-channel-card-line-oa-desc'">{{ 'tenant.channel.personal.line-oa.desc' | i18n }}</p>
                <ng-container *ngIf="getChannel(CHANNEL_TYPE.LINE_OA) as lineOaChannel">
                  <div class="line-group-send-setting" [testId]="'personal-channel-card-line-oa-group-send-setting'">
                    <span>允許向 LineGroup 主動推送</span>
                    <nz-switch
                      [nzControl]="true"
                      [ngModel]="isLineOaGroupSendAllowed(lineOaChannel)"
                      [nzLoading]="lineGroupSendUpdating"
                      (click)="onLineOaGroupSendChange(lineOaChannel, $event)"
                      [nzDisabled]="lineOaChannel.config.status !== 'Available'"
                      [testId]="'personal-channel-card-line-oa-group-send-switch'"
                    />
                  </div>
                </ng-container>
                <div
                  class="card-warning"
                  *ngIf="isChannelDisabled(CHANNEL_TYPE.LINE_OA)"
                  [testId]="'personal-channel-card-line-oa-warning'"
                >
                  <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
                  <span>{{ 'tenant.channel.personal.connect-line-login-first' | i18n }}</span>
                </div>
                <div
                  class="card-bind-readme"
                  *ngIf="!hasChannelType(CHANNEL_TYPE.LINE_OA) && !isChannelDisabled(CHANNEL_TYPE.LINE_OA)"
                  [testId]="'personal-channel-card-line-oa-readme'"
                >
                  <div class="card-bind-readme__title">
                    <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
                    {{ 'tenant.channel.personal.line-oa-bind-readme-title' | i18n }}
                  </div>
                  <p>{{ 'tenant.channel.personal.line-oa-bind-readme-item1' | i18n }}</p>
                  <p>{{ 'tenant.channel.personal.line-oa-bind-readme-item2' | i18n }}</p>
                  <button
                    nz-button
                    nzType="link"
                    class="card-bind-readme__link"
                    (click)="openLineGuide()"
                    [testId]="'personal-channel-line-guide-card-button'"
                  >
                    {{ 'tenant.channel.personal.line-guide-action' | i18n }}
                  </button>
                </div>
              </div>
              <div class="card-actions" [testId]="'personal-channel-card-line-oa-actions'">
                <ng-container *ngIf="!hasChannelType(CHANNEL_TYPE.LINE_OA); else lineOADisconnect">
                  <button
                    nz-button
                    nzType="primary"
                    [disabled]="isChannelDisabled(CHANNEL_TYPE.LINE_OA)"
                    (click)="openChannelModal(CHANNEL_TYPE.LINE_OA)"
                    [nzTooltipTitle]="
                      isChannelDisabled(CHANNEL_TYPE.LINE_OA) ? ('tenant.channel.personal.connect-line-login-first' | i18n) : null
                    "
                    nz-tooltip
                    [testId]="'personal-channel-card-line-oa-start'"
                  >
                    {{ 'tenant.channel.personal.connect' | i18n }}
                  </button>
                </ng-container>
                <ng-template #lineOADisconnect>
                  <button
                    nz-button
                    nzType="default"
                    (click)="unbindChannel(CHANNEL_TYPE.LINE_OA)"
                    [testId]="'personal-channel-card-line-oa-unbind'"
                  >
                    {{ 'tenant.channel.personal.disconnect' | i18n }}
                  </button>
                </ng-template>
              </div>
            </nz-card>
          </nz-col>

          <!-- Facebook 卡片（始终显示） -->
          <nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8" [testId]="'personal-channel-card-col-facebook'">
            <nz-card class="channel-card card-facebook" [testId]="'personal-channel-card-facebook'">
              <div class="card-header" [testId]="'personal-channel-card-facebook-header'">
                <img
                  [src]="getChannelIcon(CHANNEL_TYPE.Facebook)"
                  class="card-icon"
                  [attr.alt]="'tenant.channel.personal.facebook-name' | i18n"
                  [testId]="'personal-channel-card-facebook-icon'"
                />
                <div class="card-title" [testId]="'personal-channel-card-facebook-title'">{{
                  'tenant.channel.personal.facebook.title' | i18n
                }}</div>
                <div class="card-status" *ngIf="hasChannelType(CHANNEL_TYPE.Facebook)" [testId]="'personal-channel-card-facebook-status'">
                  <i nz-icon nzType="check-circle" nzTheme="fill"></i>
                  <span>{{ 'tenant.channel.personal.connected' | i18n }}</span>
                </div>
                <div
                  class="card-status"
                  [ngClass]="getChannelStatusClass(CHANNEL_TYPE.Facebook)"
                  *ngIf="getChannelStatusText(CHANNEL_TYPE.Facebook)"
                  [testId]="'personal-channel-card-facebook-processing-status'"
                >
                  <i nz-icon [nzType]="getChannelStatusClass(CHANNEL_TYPE.Facebook) ? 'close-circle' : 'info-circle'" nzTheme="fill"></i>
                  <span>{{ getChannelStatusText(CHANNEL_TYPE.Facebook) }}</span>
                </div>
              </div>
              <div class="card-body" [testId]="'personal-channel-card-facebook-body'">
                <p class="card-desc" [testId]="'personal-channel-card-facebook-desc'">{{
                  'tenant.channel.personal.facebook.desc' | i18n
                }}</p>
              </div>
              <div class="card-actions" [testId]="'personal-channel-card-facebook-actions'">
                <ng-container *ngIf="!shouldShowChannelUnbindAction(CHANNEL_TYPE.Facebook); else facebookDisconnect">
                  <button
                    nz-button
                    nzType="primary"
                    [disabled]="isChannelConnectDisabled(CHANNEL_TYPE.Facebook)"
                    (click)="loginWithFacebook(CHANNEL_TYPE.Facebook)"
                    [testId]="'personal-channel-card-facebook-start'"
                  >
                    {{ 'tenant.channel.personal.connect' | i18n }}
                  </button>
                </ng-container>
                <ng-template #facebookDisconnect>
                  <button
                    nz-button
                    nzType="default"
                    (click)="unbindChannel(CHANNEL_TYPE.Facebook)"
                    [testId]="'personal-channel-card-facebook-unbind'"
                  >
                    {{ 'tenant.channel.personal.disconnect' | i18n }}
                  </button>
                </ng-template>
              </div>
              <div
                class="card-error"
                *ngIf="getChannelFailureReason(CHANNEL_TYPE.Facebook)"
                [testId]="'personal-channel-card-facebook-error-reason'"
              >
                <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
                <span>{{ getChannelFailureReason(CHANNEL_TYPE.Facebook) }}</span>
              </div>
            </nz-card>
          </nz-col>

          <!-- Instagram 卡片（始终显示） -->
          <nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8" [testId]="'personal-channel-card-col-instagram'">
            <nz-card class="channel-card card-instagram" [testId]="'personal-channel-card-instagram'">
              <div class="card-header" [testId]="'personal-channel-card-instagram-header'">
                <img
                  [src]="getChannelIcon(CHANNEL_TYPE.Instagram)"
                  class="card-icon"
                  [attr.alt]="'tenant.channel.personal.instagram-name' | i18n"
                  [testId]="'personal-channel-card-instagram-icon'"
                />
                <div class="card-title" [testId]="'personal-channel-card-instagram-title'">{{
                  'tenant.channel.personal.instagram.title' | i18n
                }}</div>
                <div class="card-status" *ngIf="hasChannelType(CHANNEL_TYPE.Instagram)" [testId]="'personal-channel-card-instagram-status'">
                  <i nz-icon nzType="check-circle" nzTheme="fill"></i>
                  <span>{{ 'tenant.channel.personal.connected' | i18n }}</span>
                </div>
                <div
                  class="card-status"
                  [ngClass]="getChannelStatusClass(CHANNEL_TYPE.Instagram)"
                  *ngIf="getChannelStatusText(CHANNEL_TYPE.Instagram)"
                  [testId]="'personal-channel-card-instagram-processing-status'"
                >
                  <i nz-icon [nzType]="getChannelStatusClass(CHANNEL_TYPE.Instagram) ? 'close-circle' : 'info-circle'" nzTheme="fill"></i>
                  <span>{{ getChannelStatusText(CHANNEL_TYPE.Instagram) }}</span>
                </div>
              </div>
              <div class="card-body" [testId]="'personal-channel-card-instagram-body'">
                <p class="card-desc" [testId]="'personal-channel-card-instagram-desc'">{{
                  'tenant.channel.personal.instagram.desc' | i18n
                }}</p>
              </div>
              <div class="card-actions" [testId]="'personal-channel-card-instagram-actions'">
                <ng-container *ngIf="!shouldShowChannelUnbindAction(CHANNEL_TYPE.Instagram); else instagramDisconnect">
                  <button
                    nz-button
                    nzType="primary"
                    [disabled]="isChannelConnectDisabled(CHANNEL_TYPE.Instagram)"
                    (click)="loginWithInstagram()"
                    [testId]="'personal-channel-card-instagram-start'"
                  >
                    {{ 'tenant.channel.personal.connect' | i18n }}
                  </button>
                </ng-container>
                <ng-template #instagramDisconnect>
                  <button
                    nz-button
                    nzType="default"
                    (click)="unbindChannel(CHANNEL_TYPE.Instagram)"
                    [testId]="'personal-channel-card-instagram-unbind'"
                  >
                    {{ 'tenant.channel.personal.disconnect' | i18n }}
                  </button>
                </ng-template>
              </div>
              <div
                class="card-error"
                *ngIf="getChannelFailureReason(CHANNEL_TYPE.Instagram)"
                [testId]="'personal-channel-card-instagram-error-reason'"
              >
                <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
                <span>{{ getChannelFailureReason(CHANNEL_TYPE.Instagram) }}</span>
              </div>
            </nz-card>
          </nz-col>
        </nz-row>
      </div>

      <!-- 使用说明（底部提示区） -->
      <nz-card class="usage-card" [testId]="'personal-channel-usage-card'">
        <div class="usage-header" [testId]="'personal-channel-usage-header'">
          <h4 class="usage-title" [testId]="'personal-channel-usage-title'">{{ 'tenant.channel.personal.guide.title' | i18n }}</h4>
        </div>
        <div class="usage-content" [testId]="'personal-channel-usage-content'">
          <ul class="usage-list" [testId]="'personal-channel-usage-list'">
            <li [testId]="'personal-channel-usage-item1'">{{ 'tenant.channel.personal.guide.item1' | i18n }}</li>
            <li [testId]="'personal-channel-usage-item2'">{{ 'tenant.channel.personal.guide.item2' | i18n }}</li>
            <li [testId]="'personal-channel-usage-item3'">{{ 'tenant.channel.personal.guide.item3' | i18n }}</li>
            <li [testId]="'personal-channel-usage-item4'">{{ 'tenant.channel.personal.guide.item4' | i18n }}</li>
          </ul>
        </div>
      </nz-card>

      <!-- 表格和顶部按钮按新设计移除 -->
    </div>
  </nz-spin>
</div>

<!-- 更新现有的modal，支持查看和编辑两种模式 -->
<nz-modal
  [testId]="'personal-channel-modal'"
  [(nzVisible)]="modalVisible"
  [nzTitle]="getModalTitle()"
  [nzWidth]="840"
  nzClassName="personal-channel-modal-shell"
  [nzFooter]="isViewMode ? null : modalFooter"
  (nzOnCancel)="closeChannelModal()"
>
  <ng-container *nzModalContent [testId]="'personal-channel-modal-content'">
    <form nz-form [formGroup]="channelForm" *ngIf="currentChannel" [testId]="'personal-channel-form'">
      <!-- LINE OA 配置 -->
      <ng-container *ngIf="currentChannel.type === CHANNEL_TYPE.LINE_OA" [testId]="'personal-channel-line-oa-config'">
        <div class="line-bind-readme" [testId]="'personal-channel-line-oa-bind-readme'">
          <div class="line-bind-readme__title">
            <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
            {{ 'tenant.channel.personal.line-oa-bind-readme-title' | i18n }}
          </div>
          <p>{{ 'tenant.channel.personal.line-oa-bind-readme-content' | i18n }}</p>
          <ul>
            <li>{{ 'tenant.channel.personal.line-oa-bind-readme-item1' | i18n }}</li>
            <li>{{ 'tenant.channel.personal.line-oa-bind-readme-item2' | i18n }}</li>
            <li>{{ 'tenant.channel.personal.line-oa-bind-readme-item3' | i18n }}</li>
          </ul>
        </div>
        <nz-row [nzGutter]="24" [testId]="'personal-channel-provider-row'">
          <nz-col [nzXs]="24" [nzSm]="12" [testId]="'personal-channel-provider-col'">
            <nz-form-item [testId]="'personal-channel-provider-form-item'">
              <nz-form-label [nzSpan]="24" [nzRequired]="!isViewMode" [testId]="'personal-channel-label-provider'">{{
                'tenant.channel.personal.provider-id' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                [nzErrorTip]="isViewMode ? '' : ('tenant.channel.personal.provider-id-required' | i18n)"
                [testId]="'personal-channel-provider-control'"
              >
                <input
                  nz-input
                  formControlName="providerId"
                  [placeholder]="isViewMode ? '' : ('tenant.channel.personal.provider-id-placeholder' | i18n)"
                  [readonly]="isViewMode"
                  [testId]="'personal-channel-input-provider'"
                />
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>

        <nz-row [nzGutter]="24">
          <nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item [testId]="'personal-channel-id-form-item'">
              <nz-form-label [nzSpan]="24" [nzRequired]="!isViewMode" [testId]="'personal-channel-label-id'">{{
                'tenant.channel.personal.channel-id' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                [nzErrorTip]="isViewMode ? '' : ('tenant.channel.personal.channel-id-required' | i18n)"
                [testId]="'personal-channel-id-control'"
              >
                <input
                  [testId]="'personal-channel-input-id'"
                  nz-input
                  formControlName="channelId"
                  [placeholder]="isViewMode ? '' : ('tenant.channel.personal.channel-id-placeholder' | i18n)"
                  [readonly]="isViewMode"
                />
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col [nzXs]="24" [nzSm]="12" [testId]="'personal-channel-secret-col'">
            <nz-form-item [testId]="'personal-channel-secret-form-item'">
              <nz-form-label [nzSpan]="24" [nzRequired]="!isViewMode" [testId]="'personal-channel-label-secret'">{{
                'tenant.channel.personal.channel-secret' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                [nzErrorTip]="isViewMode ? '' : ('tenant.channel.personal.channel-secret-required' | i18n)"
                [testId]="'personal-channel-secret-control'"
              >
                <input
                  [testId]="'personal-channel-input-secret'"
                  nz-input
                  formControlName="channelSecret"
                  [placeholder]="isViewMode ? '' : ('tenant.channel.personal.channel-secret-placeholder' | i18n)"
                  [readonly]="isViewMode"
                  [type]="isViewMode ? null : 'text'"
                />
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>
      </ng-container>

      <!-- LINE Login 配置 -->
      <ng-container *ngIf="currentChannel.type === CHANNEL_TYPE.LINE_LOGIN">
        <nz-row [nzGutter]="24" [testId]="'personal-channel-line-login-provider-row'">
          <nz-col [nzXs]="24" [nzSm]="12" [testId]="'personal-channel-line-login-provider-col'">
            <nz-form-item [testId]="'personal-channel-line-login-provider-form-item'">
              <nz-form-label [nzSpan]="24" [nzRequired]="!isViewMode" [testId]="'personal-channel-line-login-provider-label'">{{
                'tenant.channel.personal.provider-id' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                [nzErrorTip]="isViewMode ? '' : ('tenant.channel.personal.provider-id-required' | i18n)"
                [testId]="'personal-channel-line-login-provider-control'"
              >
                <input
                  nz-input
                  formControlName="providerId"
                  [placeholder]="isViewMode ? '' : ('tenant.channel.personal.provider-id-placeholder' | i18n)"
                  [readonly]="isViewMode"
                  [testId]="'personal-channel-line-login-provider-input'"
                />
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>

        <nz-row [nzGutter]="24" [testId]="'personal-channel-line-login-credentials-row'">
          <nz-col [nzXs]="24" [nzSm]="12" [testId]="'personal-channel-line-login-channel-id-col'">
            <nz-form-item [testId]="'personal-channel-line-login-channel-id-form-item'">
              <nz-form-label [nzSpan]="24" [nzRequired]="!isViewMode" [testId]="'personal-channel-line-login-label-channel-id'">{{
                'tenant.channel.personal.channel-id' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                [nzErrorTip]="isViewMode ? '' : ('tenant.channel.personal.channel-id-required' | i18n)"
                [testId]="'personal-channel-line-login-channel-id-control'"
              >
                <input
                  nz-input
                  formControlName="channelId"
                  [placeholder]="isViewMode ? '' : ('tenant.channel.personal.channel-id-placeholder' | i18n)"
                  [readonly]="isViewMode"
                  [testId]="'personal-channel-line-login-input-channel-id'"
                />
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col [nzXs]="24" [nzSm]="12" [testId]="'personal-channel-line-login-channel-secret-col'">
            <nz-form-item [testId]="'personal-channel-line-login-channel-secret-form-item'">
              <nz-form-label [nzSpan]="24" [nzRequired]="!isViewMode" [testId]="'personal-channel-line-login-label-channel-secret'">{{
                'tenant.channel.personal.channel-secret' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                [nzErrorTip]="isViewMode ? '' : ('tenant.channel.personal.channel-secret-required' | i18n)"
                [testId]="'personal-channel-line-login-channel-secret-control'"
              >
                <input
                  nz-input
                  formControlName="channelSecret"
                  [placeholder]="isViewMode ? '' : ('tenant.channel.personal.channel-secret-placeholder' | i18n)"
                  [readonly]="isViewMode"
                  [type]="isViewMode ? null : 'text'"
                  [testId]="'personal-channel-line-login-input-channel-secret'"
                />
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>
      </ng-container>

      <!-- Facebook 配置 -->
      <ng-container *ngIf="currentChannel.type === 'Facebook'" [testId]="'personal-channel-facebook-config'">
        <div class="channel-table-view" [testId]="'personal-channel-facebook-table-view'">
          <nz-table
            class="channel-info-table"
            [nzData]="[currentChannel.config]"
            [nzShowPagination]="false"
            [nzFrontPagination]="false"
            [testId]="'personal-channel-facebook-info-table'"
          >
            <thead [testId]="'personal-channel-facebook-table-head'">
              <tr [testId]="'personal-channel-facebook-table-header-row'">
                <th scope="col" nzWidth="68px" [testId]="'personal-channel-facebook-header-avatar'">{{
                  'tenant.channel.personal.avatar' | i18n
                }}</th>
                <th scope="col" nzWidth="362px" [testId]="'personal-channel-facebook-header-page-id'">{{
                  'tenant.channel.personal.page-id' | i18n
                }}</th>
                <th scope="col" nzWidth="362px" [testId]="'personal-channel-facebook-header-page-name'">{{
                  'tenant.channel.personal.page-name' | i18n
                }}</th>
              </tr>
            </thead>
            <tbody [testId]="'personal-channel-facebook-table-body'">
              <tr [testId]="'personal-channel-facebook-table-row'">
                <td [testId]="'personal-channel-facebook-cell-avatar'">
                  <img
                    [src]="getChannelIcon(currentChannel.type)"
                    class="channel-icon"
                    [attr.alt]="'tenant.channel.personal.facebook-name' | i18n"
                    [testId]="'personal-channel-facebook-icon'"
                  />
                </td>
                <td [testId]="'personal-channel-facebook-cell-page-id'">{{ currentChannel.config.code }}</td>
                <td [testId]="'personal-channel-facebook-cell-page-name'">{{ currentChannel.config.name ?? '-' }}</td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </ng-container>

      <!-- Instagram 配置 -->
      <ng-container *ngIf="currentChannel.type === 'Instagram'" [testId]="'personal-channel-instagram-config'">
        <div class="channel-table-view" [testId]="'personal-channel-instagram-table-view'">
          <nz-table
            class="channel-info-table"
            [nzData]="[currentChannel.config]"
            [nzShowPagination]="false"
            [nzFrontPagination]="false"
            [testId]="'personal-channel-instagram-info-table'"
          >
            <thead [testId]="'personal-channel-instagram-table-head'">
              <tr [testId]="'personal-channel-instagram-table-header-row'">
                <th scope="col" nzWidth="68px" [testId]="'personal-channel-instagram-header-avatar'">{{
                  'tenant.channel.personal.avatar' | i18n
                }}</th>
                <th scope="col" nzWidth="241px" [testId]="'personal-channel-instagram-header-account-id'">{{
                  'tenant.channel.personal.account-id' | i18n
                }}</th>
                <th scope="col" nzWidth="241px" [testId]="'personal-channel-instagram-header-account-name'">{{
                  'tenant.channel.personal.account-name' | i18n
                }}</th>
                <th scope="col" nzWidth="241px" [testId]="'personal-channel-instagram-header-linked-facebook-page'">{{
                  'tenant.channel.personal.linked-facebook-page' | i18n
                }}</th>
              </tr>
            </thead>
            <tbody [testId]="'personal-channel-instagram-table-body'">
              <tr [testId]="'personal-channel-instagram-table-row'">
                <td [testId]="'personal-channel-instagram-cell-avatar'">
                  <img
                    [src]="getChannelIcon(currentChannel.type)"
                    class="channel-icon"
                    [attr.alt]="'tenant.channel.personal.instagram-name' | i18n"
                    [testId]="'personal-channel-instagram-icon'"
                  />
                </td>
                <td [testId]="'personal-channel-instagram-cell-account-id'">{{ currentChannel.config.code }}</td>
                <td [testId]="'personal-channel-instagram-cell-account-name'">{{ currentChannel.config.ig_name ?? '-' }}</td>
                <td [testId]="'personal-channel-instagram-cell-linked-facebook-page'">{{ currentChannel.config.groupName ?? '-' }}</td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </ng-container>
    </form>
  </ng-container>

  <!-- 编辑模式的footer -->
  <ng-template #modalFooter [testId]="'personal-channel-modal-footer'">
    <button nz-button nzType="default" (click)="closeChannelModal()" [testId]="'personal-channel-cancel-btn'">{{
      'tenant.channel.personal.cancel' | i18n
    }}</button>
    <button
      nz-button
      nzType="primary"
      [nzLoading]="loading"
      [disabled]="!isFormValid()"
      (click)="submitChannelConfig()"
      [testId]="'personal-channel-connect-submit-btn'"
    >
      {{ 'tenant.channel.personal.connect' | i18n }}
    </button>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="lineGuideVisible"
  [nzTitle]="'tenant.channel.personal.line-guide-title' | i18n"
  [nzWidth]="860"
  [nzCancelText]="'common.close' | i18n"
  [nzFooter]="null"
  nzClassName="line-guide-modal"
  (nzOnCancel)="closeLineGuide()"
  [testId]="'personal-channel-line-guide-modal'"
>
  <ng-container *nzModalContent>
    <div class="line-guide" [testId]="'personal-channel-line-guide-content'">
      <div class="line-guide__lead">
        <strong>{{ 'tenant.channel.personal.line-guide-lead-title' | i18n }}</strong>
        <p>{{ 'tenant.channel.personal.line-guide-lead-content' | i18n }}</p>
        <div class="line-guide__links">
          <a href="https://developers.line.biz/console/" target="_blank" rel="noopener noreferrer">LINE Developers Console</a>
          <a href="https://manager.line.biz/" target="_blank" rel="noopener noreferrer">LINE Official Account Manager</a>
        </div>
      </div>

      <section class="line-guide__step">
        <div class="line-guide__step-number">1</div>
        <div class="line-guide__step-body">
          <h4>{{ 'tenant.channel.personal.line-guide-step1-title' | i18n }}</h4>
          <p>{{ 'tenant.channel.personal.line-guide-step1-content' | i18n }}</p>
          <img src="assets/images/guides/line/line-developers-login.png" [alt]="'tenant.channel.personal.line-guide-step1-alt' | i18n" />
          <img
            src="assets/images/guides/line/line-provider-create-full.png"
            [alt]="'tenant.channel.personal.line-guide-step1-alt' | i18n"
          />
        </div>
      </section>

      <section class="line-guide__step">
        <div class="line-guide__step-number">2</div>
        <div class="line-guide__step-body">
          <h4>{{ 'tenant.channel.personal.line-guide-step2-title' | i18n }}</h4>
          <p>{{ 'tenant.channel.personal.line-guide-step2-content' | i18n }}</p>
          <img
            src="assets/images/guides/line/line-provider-channels-full.png"
            [alt]="'tenant.channel.personal.line-guide-step2-alt' | i18n"
          />
          <img src="assets/images/guides/line/line-provider-id-full.png" [alt]="'tenant.channel.personal.line-guide-step2-alt' | i18n" />
        </div>
      </section>

      <section class="line-guide__step">
        <div class="line-guide__step-number">3</div>
        <div class="line-guide__step-body">
          <h4>{{ 'tenant.channel.personal.line-guide-step3-title' | i18n }}</h4>
          <p>{{ 'tenant.channel.personal.line-guide-step3-content' | i18n }}</p>
          <img
            src="assets/images/guides/line/line-login-channel-id-full.png"
            [alt]="'tenant.channel.personal.line-guide-step3-alt' | i18n"
          />
          <img
            src="assets/images/guides/line/line-login-channel-secret-full.png"
            [alt]="'tenant.channel.personal.line-guide-step3-alt' | i18n"
          />
        </div>
      </section>

      <section class="line-guide__step">
        <div class="line-guide__step-number">4</div>
        <div class="line-guide__step-body">
          <h4>{{ 'tenant.channel.personal.line-guide-step4-title' | i18n }}</h4>
          <p>{{ 'tenant.channel.personal.line-guide-step4-content' | i18n }}</p>
          <img
            src="assets/images/guides/line/messaging-api-channel-id-full.png"
            [alt]="'tenant.channel.personal.line-guide-step4-alt' | i18n"
          />
          <img
            src="assets/images/guides/line/messaging-api-channel-secret-full.png"
            [alt]="'tenant.channel.personal.line-guide-step4-alt' | i18n"
          />
        </div>
      </section>

      <section class="line-guide__step">
        <div class="line-guide__step-number">5</div>
        <div class="line-guide__step-body">
          <h4>{{ 'tenant.channel.personal.line-guide-step5-title' | i18n }}</h4>
          <p>{{ 'tenant.channel.personal.line-guide-step5-content' | i18n }}</p>
          <img
            src="assets/images/guides/line/personal-channel-line-login.png"
            [alt]="'tenant.channel.personal.line-guide-step5-alt' | i18n"
          />
        </div>
      </section>

      <section class="line-guide__step">
        <div class="line-guide__step-number">6</div>
        <div class="line-guide__step-body">
          <h4>{{ 'tenant.channel.personal.line-guide-step6-title' | i18n }}</h4>
          <p>{{ 'tenant.channel.personal.line-guide-step6-content' | i18n }}</p>
          <img src="assets/images/guides/line/personal-channel-line-oa.png" [alt]="'tenant.channel.personal.line-guide-step6-alt' | i18n" />
        </div>
      </section>

      <section class="line-guide__step">
        <div class="line-guide__step-number">7</div>
        <div class="line-guide__step-body">
          <h4>{{ 'tenant.channel.personal.line-guide-step7-title' | i18n }}</h4>
          <p>{{ 'tenant.channel.personal.line-guide-step7-content' | i18n }}</p>
          <img
            src="assets/images/guides/line/messaging-api-webhook-full.png"
            [alt]="'tenant.channel.personal.line-guide-step7-alt' | i18n"
          />
        </div>
      </section>
    </div>
  </ng-container>
</nz-modal>

<!-- 在适当位置添加提示框 -->
<nz-alert
  [testId]="'personal-channel-success-alert'"
  *ngIf="showSuccessAlert"
  nzType="success"
  [nzMessage]="'tenant.channel.personal.copy-success' | i18n"
  [nzDescription]="'tenant.channel.personal.webhook-instruction' | i18n"
  nzShowIcon
  nzCloseable="false"
  class="webhook-success-alert"
/>
<channel-error-report #errorReportComponent [testId]="'personal-channel-error-report'" />
